export const accountComponents = {
  // OtaLinksBar.vue — OTA links bar
  otaLinks: {
    copied: "Skopiowano!",
    copy: "Kopiuj",
    edit: "Edytuj",
    remove: "Usuń",
    addLink: "Link OTA",
    modalEyebrow: "Link oferty w serwisie OTA",
    modalEyebrowUnit: "Link tej jednostki w OTA",
    editTitle: "Edytuj link",
    addTitle: "Dodaj link OTA",
    modalHint: "Proszę wkleić publiczny adres URL <b>tej oferty</b> w serwisie OTA. Pozwala to szybko go skopiować i otworzyć.",
    urlLabel: "URL oferty",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    save: "Zapisz link",
    saveError: "Nie udało się zapisać linku. Proszę sprawdzić URL.",
    fromListing: "z ogłoszenia",
    inheritedNote: "To link ogłoszenia. Dopóki ta jednostka nie ma własnego, wysyłamy właśnie ten.",
    override: "Ustaw własny",
    modalHintUnit: "Wklej publiczny adres URL <b>tej jednostki</b> w OTA. Jeśli go ustawisz, wysyłamy ten; jeśli zostawisz pusty, wysyłamy adres ogłoszenia.",
  },

  // GuestJourneySimulator.vue — guest journey simulator
  journeySim: {
    title: "Symulacja podróży gościa",
    badge: "Test",
    intro: "Odtworzenie całego procesu, od rezerwacji po opinię, w czacie WhatsApp. Proszę podać imię i numer, a następnie nacisnąć <strong>play</strong>. Po włączeniu opcji «Wyślij na telefon» każda wiadomość jest naprawdę wysyłana na ten numer, można więc ją sprawdzić i porozmawiać z Agentem AI.",
    guestNameLabel: "Imię i nazwisko gościa",
    guestNamePlaceholder: "np. Laura García",
    phoneLabel: "Numer WhatsApp (do testów)",
    phoneHint: "Format międzynarodowy, np. +34 600123456",
    toggleTitle: "Wyślij też na telefon",
    toggleDesc: "Każdy krok jest naprawdę wysyłany na powyższy numer",
    warn: "Najpierw należy wysłać «cześć» na ten numer z własnego telefonu, aby otworzyć 24-godzinne okno WhatsApp; wtedy wiadomości przyjdą natychmiast.",
    reset: "Zacznij od nowa",
    prev: "Poprzedni",
    pause: "Pauza",
    play: "Odtwórz",
    continue: "Kontynuuj",
    next: "Następny",
    stepProgress: "Krok {current} z {total}",
    guestFallback: "Gość",
    propertyFallback: "obiekt",
    testNumberFallback: "numer testowy",
    dayLabel: "Podróż gościa",
    loadingMsgs: "Wczytywanie wiadomości…",
    pressPlay: "Proszę nacisnąć <strong>Odtwórz</strong>, aby rozpocząć podróż ▶",
    hintSending: "Wysyłka na żywo włączona · każdy krok trafia na numer {phone}",
    hintSimulated: "Widok symulowany · aby sprawdzić na prawdziwym telefonie, należy włączyć «Wyślij na telefon»",
    toastInvalidPhone: "Proszę podać prawidłowy numer WhatsApp, aby wysłać na telefon.",
    toastSendFailed: "Nie udało się wysłać.",
    toastSendMobileFailed: "Nie udało się wysłać na telefon.",
    // Simulated WhatsApp messages ({{...}} are resolved by resolve())
    msgConfirmation: "Dzień dobry, *{{nombre_huesped}}* 👋\n\nRezerwacja w obiekcie *{{nombre_alojamiento}}* jest potwierdzona ✅\n\nKod rezerwacji: *6233Q1VC5*\nTerminy: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nPrzez ten WhatsApp można poprosić o link do check-inu online i otrzymać instrukcje dojazdu.",
    msgCheckinPrompt: "*Dzień dobry* 👋 Tu wirtualny asystent obiektu *{{nombre_alojamiento}}*.\n\nProszę nacisnąć *Ok*, aby przejść do check-inu.",
    msgChooseLanguage: "Wybierz język · Choose your language",
    msgCheckinLink: "*Dziękujemy* 👋 Oto link do check-inu 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 Witamy w obiekcie *{{nombre_alojamiento}}*, {{nombre_huesped}}!\n\nDziękujemy za dopełnienie rejestracji. Poniżej wszystkie informacje o pobycie.",
    msgAccess: "🔒🔑 *Kod dostępu · {{nombre_alojamiento}}*\n\nKod: *58117*\n\nWażny przez cały pobyt.",
    msgArrival: "🏡 *Instrukcje dojazdu*\n\nPo przyjeździe proszę podejść do głównego wejścia i wpisać swój kod na zamku. 🔑\n\nUdanego pobytu! ✨",
    msgGuestCheckout: "Dzień dobry, o której godzinie jest check-out?",
    msgCheckoutReply: "Dzień dobry! Check-out jest do *12:00* 🕚 Jeśli trzeba wyjechać później, mogę sprawdzić możliwość późnego check-outu 😊",
    msgCheckout: "Dzień dobry, *{{nombre_huesped}}* 👋\n\nPrzypominamy, że *pobyt kończy się jutro* w obiekcie *{{nombre_alojamiento}}*.\n\n🕚 Najpóźniejsza godzina check-outu to *{{hora_salida}}*.\n\nDziękujemy za wizytę i szerokiej drogi! 😊",
    msgReview: "⭐ Jak minął pobyt w obiekcie *{{nombre_alojamiento}}*, {{nombre_huesped}}?\n\nChętnie poznamy opinię. Prosimy o nią tutaj 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — guest journey timeline
  journeyTimeline: {
    title: "Podróż gościa",
    subtitle: "Od rezerwacji do wyjazdu. Najechanie na zdarzenie pokazuje wiadomość.",
    disabled: "Wyłączone",
    clickToConfigure: "Kliknij, aby skonfigurować",
    nameFallback: "obiekt",
    // Node labels
    labelLead: "Rezerwacja / Lead",
    labelConfirm: "Potwierdzenie",
    labelCheckinLink: "Link do check-inu",
    labelWelcome: "Powitanie",
    labelAccess: "Dostęp / Zamek",
    labelArrival: "Instrukcje dojazdu",
    labelCheckout: "Wiadomość o wyjeździe",
    labelReview: "Opinia",
    // Timing of each node
    whenLead: "Przy rezerwacji lub wiadomości",
    whenConfirm: "Rezerwacja potwierdzona",
    whenCheckinLink: "Przed przyjazdem",
    whenWelcome: "Po rejestracji",
    whenAccess: "Dzień przyjazdu",
    whenArrival: "Dzień przyjazdu",
    whenCheckout: "Dzień przed check-outem",
    whenReview: "Po check-oucie",
    // WhatsApp previews
    previewLead: "👋 Dzień dobry! Tu wirtualny asystent obiektu *{name}*.\n\nSłużę pomocą przy rezerwacji i odpowiem na pytania.",
    previewConfirm: "Dzień dobry, *Laura García* 👋\n\nRezerwacja w obiekcie *{name}* jest potwierdzona ✅\n\nKod rezerwacji: *6233Q1VC5*\nTerminy: *05/06/2026* – *07/06/2026* 📅\n\nPrzez ten WhatsApp można poprosić o link do check-inu online, a także otrzymać instrukcje dojazdu.\nW razie potrzeby pomocy przed pobytem lub w jego trakcie prosimy pisać tutaj 💬",
    previewWelcome: "👋 Witamy w obiekcie *{name}*!\n\nDziękujemy za dopełnienie rejestracji. Poniżej wszystkie informacje o pobycie.",
    previewAccess: "🔒🔑 *Kod dostępu · {name}*\n\nKod: *58117*\n\nWażny przez cały pobyt.",
    previewArrival: "🏡 *Instrukcje dojazdu*\n\nPo przyjeździe proszę podejść do głównego wejścia obiektu. 🔑\n\nUdanego pobytu! ✨",
    previewCheckout: "Dzień dobry 👋\n\nPrzypominamy, że *pobyt kończy się jutro* w obiekcie *{name}*.\n\n🕚 Najpóźniejsza godzina check-outu to *12:00*.\n\nSzerokiej drogi! 😊",
    previewReview: "⭐ Jak minął pobyt w obiekcie *{name}*?\n\nChętnie poznamy opinię. Prosimy o nią tutaj 👉 …",
    previewLeadNoWaba: "📲 *Aktywacja Agenta AI* pozwala obsługiwać nowe rezerwacje przez WhatsApp po podłączeniu własnego numeru.\n\nDzięki temu asystent odpowie osobom, które nie są jeszcze klientami, wyjaśni wątpliwości dotyczące obiektów i poprowadzi je do rezerwacji.",
    // Full "Check-in link" conversation
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Wybierz język · Choose your language",
    chatCheckinLink: "*Dziękujemy* 👋 Oto link do check-inu. 😎\n\nhttps://guest.wacheckin.com/…",
    // Access messages (locks)
    lockLabelFallback: "Wejście",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nKod dostępu: *58117*\n\nWażny przez cały pobyt.",
    lockNone: "🔑 *{label} · {name}*\n\nSkrzynka na klucze otwiera się kodem: *{code}*\n\nW środku znajdują się klucze do obiektu.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nKod zamka: *{code}*\n\nSłuży do otwarcia drzwi.",
    // Departure message (fallback)
    checkoutFallback: "Dzień dobry, *María* 👋\n\nPrzypominamy, że pobyt kończy się jutro w obiekcie *{name}*.\n\n🕚 Najpóźniejsza godzina check-outu to *{time}*.\n\nDziękujemy za pobyt i szerokiej drogi! 😊",
  },

  // ListingIcalPanel.vue — iCal sync panel
  icalPanel: {
    eyebrow: "Kalendarz iCal",
    heading: "Synchronizacja iCal",
    pageDesc: "Eksport rezerwacji na inne platformy i import zewnętrznych kalendarzy w celu automatycznego blokowania terminów w ofercie.",
    loading: "Wczytywanie konfiguracji…",
    exportLabel: "Link iCal (eksport)",
    exportDesc: "Proszę skopiować ten link i wkleić go w Airbnb, Booking.com lub dowolnej platformie obsługującej synchronizację iCal. Rezerwacje zostaną pobrane automatycznie.",
    copied: "Skopiowano",
    copy: "Kopiuj",
    tipAllUnits: "Ten link zawiera rezerwacje <strong>wszystkich jednostek</strong> oferty.",
    tipHotelRooms: "Każdy <strong>pokój fizyczny</strong> ma własny link. Po podłączeniu go w Airbnb/Booking dla konkretnego pokoju eksportowane będą wyłącznie rezerwacje TEGO pokoju.",
    importLabel: "Kalendarze zewnętrzne (import)",
    syncing: "Synchronizowanie…",
    syncAll: "Synchronizuj wszystkie",
    importDesc: "Proszę wkleić adresy iCal z innych platform (Airbnb, Booking.com itd.), a Wacheckin automatycznie zablokuje te terminy w kalendarzu.",
    lastSync: "Ostatnia synchronizacja: {date}",
    delete: "Usuń",
    empty: "Brak podłączonych kalendarzy zewnętrznych.",
    addExternal: "Dodaj kalendarz zewnętrzny",
    newExternal: "Nowy kalendarz zewnętrzny",
    nameLabel: "Nazwa kalendarza",
    namePlaceholder: "np. Airbnb - Apt 1",
    physicalRoom: "Pokój fizyczny",
    listingUnit: "Jednostka oferty",
    selectRoomPlaceholder: "Proszę wybrać pokój…",
    selectUnitPlaceholder: "Proszę wybrać jednostkę…",
    urlLabel: "URL kalendarza iCal",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveSync: "Zapisz i synchronizuj",
    defaultGroup: "Pokoje",
    toastLoadError: "Nie udało się wczytać konfiguracji iCal.",
    toastSelectUnit: "Proszę wybrać pokój lub jednostkę.",
    toastAdded: "Kalendarz dodany i zsynchronizowany.",
    toastAddError: "Błąd podczas dodawania kalendarza.",
    deleteConfirm: 'Usunąć "{name}" i wszystkie zablokowane przez niego rezerwacje?',
    toastDeleted: "Kalendarz usunięty.",
    toastDeleteError: "Nie udało się usunąć kalendarza.",
    toastSyncError: "Błąd synchronizacji.",
  },

  // ListingIcalModal.vue — iCal sync modal
  icalModal: {
    title: "Synchronizacja iCal",
    loading: "Wczytywanie konfiguracji…",
    exportLabel: "Link iCal (eksport)",
    exportDesc: "Proszę skopiować ten link i wkleić go w Airbnb, Booking.com lub dowolnej platformie obsługującej synchronizację iCal. Rezerwacje zostaną pobrane automatycznie.",
    copied: "Skopiowano",
    copy: "Kopiuj",
    tipAllUnits: "Ten link zawiera rezerwacje <strong>wszystkich jednostek</strong> oferty.",
    tipHotelRooms: "Każdy <strong>pokój fizyczny</strong> ma własny link. Po podłączeniu go w Airbnb/Booking dla konkretnego pokoju eksportowane będą wyłącznie rezerwacje TEGO pokoju.",
    importLabel: "Kalendarze zewnętrzne (import)",
    syncing: "Synchronizowanie…",
    syncAll: "Synchronizuj wszystkie",
    importDesc: "Proszę wkleić adresy iCal z innych platform (Airbnb, Booking.com itd.), a Wacheckin automatycznie zablokuje te terminy w kalendarzu.",
    lastSync: "Ostatnia synchronizacja: {date}",
    delete: "Usuń",
    empty: "Brak podłączonych kalendarzy zewnętrznych.",
    addExternal: "Dodaj kalendarz zewnętrzny",
    newExternal: "Nowy kalendarz zewnętrzny",
    nameLabel: "Nazwa kalendarza",
    namePlaceholder: "np. Airbnb - Apt 1",
    physicalRoom: "Pokój fizyczny",
    listingUnit: "Jednostka oferty",
    selectRoomPlaceholder: "Proszę wybrać pokój…",
    selectUnitPlaceholder: "Proszę wybrać jednostkę…",
    urlLabel: "URL kalendarza iCal",
    cancel: "Anuluj",
    saveSync: "Zapisz i synchronizuj",
    defaultGroup: "Pokoje",
    toastLoadError: "Nie udało się wczytać konfiguracji iCal.",
    toastSelectUnit: "Proszę wybrać pokój lub jednostkę.",
    toastAdded: "Kalendarz dodany i zsynchronizowany.",
    toastAddError: "Błąd podczas dodawania kalendarza.",
    deleteConfirm: 'Usunąć "{name}" i wszystkie zablokowane przez niego rezerwacje?',
    toastDeleted: "Kalendarz usunięty.",
    toastDeleteError: "Nie udało się usunąć kalendarza.",
    toastSyncError: "Błąd synchronizacji.",
  },
};
